module.exports = __webpack_public_path__ + "static/design_menu-c13ab231e35848cee9b0df6ce45f86b3.png";